import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CustomDrawerHeader from './CustomDrawerHeader';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import CustomContainer from './CustomContainer';
import CustomMenu from './CustomMenu';

const drawerWidth = 240;
const heightMenu = 64;

const useStyles = makeStyles((theme) => ({
    main: {
        alignItems: 'center',
        marginLeft: `calc(${theme.spacing(9)} + 1px)`,
        marginTop: heightMenu,
    },
    main_menu_open: {
        marginLeft: drawerWidth,
        marginTop: heightMenu,
    },
}));

export default function CustomMain(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(window.innerWidth <= 768 ? false : true);

    React.useEffect(() => {
        function handleResize() {
            console.log("window.innerWidth===", window.innerWidth)
            if(window.innerWidth <= 768 ){
                setOpen(false);
            }
        }
        window.addEventListener('resize', handleResize)
    }, []);
    
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };
    const handleDrawer = () => {
        setOpen(!open);
    };

    return (
        <CustomContainer open={open}>
            <CustomMenu 
                open={open} 
                handleDrawerOpen={handleDrawerOpen}
                handleDrawerClose={handleDrawerClose}
                handleDrawer={handleDrawer}
            />
            {props.children}
        </CustomContainer>
    );
}